import RefreshButton from "components/RefreshButton";
import SearchButton from "components/SearchButton";
import TextInput from "components/TextInput";
import React, { useState } from "react";
import { SetterOrUpdater } from "recoil";

export default function TableFilters(props: {
  filterText:
    | SetterOrUpdater<string>
    | React.Dispatch<React.SetStateAction<string>>;
  setRecent?: React.Dispatch<React.SetStateAction<string>>;
  recentText?: string;
  defaultText: string;
  textInputName: string;
  columnDetails: string;
  disabledButton: boolean;
  disabledTextBox: boolean;
}) {
  const {
    setRecent,
    recentText,
    filterText,
    textInputName,
    columnDetails,
    disabledButton,
    disabledTextBox,
    defaultText,
  } = props;
  const [inputValue, setInputValue] = useState("");
  const [searched, setSearched] = useState(false);
  if (recentText) {
    filterText("");
  }
  const FilterData = () => {
    filterText(
      inputValue != "" ? inputValue : recentText ? recentText : defaultText
    );
    if (setRecent) setRecent("");
    setSearched(false);
  };

  return (
    <div className="">
      <div className="grid grid-cols-12 space-x-2">
        <div className="col-span-3">
          <TextInput
            name={textInputName}
            placeholder={columnDetails}
            value={
              inputValue != "" || searched
                ? inputValue
                : recentText
                ? recentText
                : defaultText
            }
            disabled={disabledTextBox ? true : false}
            onChange={(e) => {
              setInputValue(e.target.value);
              e.target.value === "" && filterText("");
              setSearched(true);
              if (e.target.value == "" && setRecent) {
                setRecent("");
              }
            }}
          />
        </div>
        <div className="flex flex-auto space-x-2">
          <SearchButton
            buttonValue="Search"
            className={
              (defaultText == "" && inputValue === "" && recentText === "") ||
              disabledButton
                ? "opacity-50"
                : "opacity-100"
            }
            disabled={
              (defaultText == "" && inputValue === "" && recentText === "") ||
              disabledButton
                ? true
                : false
            }
            onClick={() => {
              FilterData();
            }}
          />
          <div>
            <RefreshButton
              className={
                (defaultText == "" && inputValue === "" && recentText === "") ||
                disabledButton
                  ? "opacity-50"
                  : "opacity-100"
              }
              disabled={
                (defaultText == "" && inputValue === "" && recentText === "") ||
                disabledButton
                  ? true
                  : false
              }
              onClick={() => {
                filterText("");
                setInputValue("");
                if (setRecent) setRecent("");
                setSearched(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
